import React, { useEffect, useState } from 'react';
import Loading from '../Loading';
import { ReactComponent as SearchMagnifyIcon } from '../../assets/svg/SearchMagnifyIcon.svg';
import { fileSystemUrl } from '../../server/connections';
import { getCourseCategories, getPractices, getSolutionCategories } from '../../server/server';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaIcons } from 'react-icons/fa';

function SolutionCategoriesHome() {
	const navigate = useNavigate();
	const [currentPath, setCurrentPath] = useState(window.location.pathname);
	const [isParent, setIsParent] = useState(window.location.pathname.includes('parent'));
	const [categories, setCategories] = useState<any>([]);
	const [allCategories, setAllCategories] = useState<any>([]);
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		loadCategories();
	}, [currentPath]);

	useEffect(() => {
		handleUrlChange();
	}, [window.location.pathname]);

	useEffect(() => {
		if (allCategories.length !== 0) filterCategoriesBySearchTerm(allCategories, searchTerm);
	}, [searchTerm]);

	const loadCategories = async () => {
		setLoading(true);
		const resp = await getSolutionCategories(isParent ? 'PARENT' : 'CHILD');
		if (resp.status === 200) {
			setCategories(resp.data);
			setAllCategories(resp.data);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const filterCategoriesBySearchTerm = (categories = allCategories, text = searchTerm) => {
		setCategories(categories?.filter((e: any) => e?.name?.toLowerCase().includes(text?.toLowerCase()) || e?.description?.toLowerCase().includes(text?.toLowerCase())));
	};

	const handleUrlChange = () => {
		setCurrentPath(window.location.pathname);
		setIsParent(window.location.pathname.includes('parent'));
	};

	const openCategory = (category: any) => {
		if (isParent) navigate(`/parent-solution-categories/${category?.id}`);
		else navigate(`/solution-categories/${category?.id}`);
	};

	const CategoryButton = (category: any) => {
		return (
			<div
				className='my-[5px] flex cursor-pointer flex-row gap-5 rounded-[10px] border border-[#F8F8FB] bg-[#F8F8FB] px-[40px] py-[25px] duration-300 ease-out hover:border-mudPurple'
				onClick={() => openCategory(category)}
				key={category.id}
			>
				{!!category.image && (
					<div className='w-full max-w-[160px] shrink-0'>
						<img
							className='h-[120px] w-full rounded-xl object-cover'
							src={fileSystemUrl + '/' + category.image?.url}
							alt={category?.name || 'Category image'}
						/>
					</div>
				)}
				<div className='flex flex-1 flex-col justify-center'>
					<h3 className='text-[20px] font-semibold leading-7 text-primaryViolet'>{category.name}</h3>
					<p className='two-lines-of-text mt-[8px] text-[14px] font-medium leading-5 text-mudPurple'>{category.description}</p>
				</div>
				<div className='flex w-[300px] shrink-0 flex-row justify-between gap-5'>
					<div className='flex flex-1 flex-col justify-center gap-2'>
						<div className='flex flex-row items-center'>
							<span className='text-[16px] font-semibold leading-6 text-primaryViolet'>Locale:</span>
							<span className='ml-2 truncate text-[16px] font-medium leading-6 text-primaryViolet'>{category?.locale?.name || 'N/A'}</span>
						</div>
						<div className='flex flex-row items-center'>
							<span className='whitespace-nowrap text-[16px] font-semibold leading-6 text-primaryViolet'>Code name:</span>
							<span className='ml-2 truncate text-[16px] font-medium leading-6 text-primaryViolet'>{category?.codeName || 'N/A'}</span>
						</div>
					</div>
					<div className='flex shrink-0 items-center justify-center'>
						<div className='flex h-[40px] cursor-pointer items-center justify-center px-2 text-primaryViolet'>
							<FaEdit style={{ width: 20, height: 20 }} />
						</div>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className='flex h-screen flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full min-h-fit   max-w-[1200px] px-[10px]'>
				<div className='w-full min-h-[calc(100vh-80px)]  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					<div className='mb-[30px] flex flex-row  items-end'>
						<p className='flex-1 text-[40px] leading-[50px] font-bold text-darkViolet'>Solution categories</p>
						{/* <div
							className={`cursor-pointer flex h-[50px]  w-[180px] items-center justify-center rounded-full border border-primaryViolet
                                bg-white text-lg  font-semibold text-primaryViolet transition  hover:bg-primaryViolet hover:text-brandYellow`}
							onClick={() => {
								navigate(`/category/new`);
							}}
						>
							Add new category
						</div> */}
					</div>
					<div className='mb-[40px] flex w-full flex-row gap-5'>
						<div className='flex  h-[50px] flex-1 flex-row items-center rounded-full border border-primaryViolet  px-4'>
							<input type='text' placeholder='Search' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='h-full flex-1 rounded-full  outline-none  text-[18px] leading-6  font-semibold text-primaryViolet placeholder:font-medium placeholder:text-mudPurple' autoComplete='off' />
							<SearchMagnifyIcon />
						</div>
					</div>
					{loading && (
						<div className='flex w-full flex-grow items-center justify-center'>
							<Loading size={70} primaryColor='#5E639B' stroke={3} />
						</div>
					)}
					{categories.length === 0 && !loading && (
						<div className='flex w-full flex-grow  items-center justify-center'>
							{' '}
							<p className='text-center text-[14px] font-medium leading-5 text-mudPurple'>
								This list is empty right now.
								<br /> Consider adding new category...
							</p>{' '}
						</div>
					)}
					{!loading && categories?.map(CategoryButton)}
				</div>
			</div>
		</div>
	);
}

export default SolutionCategoriesHome;
